import { motion } from "framer-motion";

export default function HexDivider() {
  return (
    <div className="relative flex items-center justify-center py-6" aria-hidden>
      <div className="h-px w-full max-w-4xl bg-gradient-to-r from-transparent via-turq/25 to-transparent" />
      <motion.svg
        viewBox="0 0 64 64"
        className="absolute w-9 h-9 hex-glow"
        initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
        whileInView={{ opacity: 1, rotate: 0, scale: 1 }}
        viewport={{ once: true, margin: "-20px" }}
        transition={{ type: "spring", stiffness: 160, damping: 16 }}
      >
        <defs>
          <linearGradient id="divgrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00F5D4" />
            <stop offset="100%" stopColor="#2563EB" />
          </linearGradient>
        </defs>
        <polygon
          points="32,4 56,18 56,46 32,60 8,46 8,18"
          fill="#0B0F17"
          stroke="url(#divgrad)"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <circle cx="32" cy="22" r="3.4" fill="#00F5D4" />
        <rect x="29.6" y="28.5" width="4.8" height="13" rx="1.6" fill="#F8FAFC" />
      </motion.svg>
    </div>
  );
}
